import Key from "csi/core/Key";
import SpecBuilder from "csi/core/SpecBuilder";
import locale from "csi/locale";
import { getEnumList } from "csi/reflection/reflectionData";
import xml from "csi/xml";

const COLOR_MATERIAL_SAMPLES = "ColorMaterialSamples";

/** replace ColorMaterialSamples key with one for each enum value of the list with the same name */
export function augmentColorMaterialKeys(keys: Key[]): Key[] {
	const index = keys.findIndex(({ id }) => id === COLOR_MATERIAL_SAMPLES);

	if (index >= 0) {
		const { extendedPath } = keys[index];

		keys.splice(index, 1);

		getEnumList(COLOR_MATERIAL_SAMPLES)?.activeValues?.forEach(({ name }) => {
			keys.push(new Key({
				id: COLOR_MATERIAL_SAMPLES,
				index: name,
				extendedPath,
			}));
		});
	}

	return keys;
}

SpecBuilder.registerNameFunction(
	({ id, index }) => (id === COLOR_MATERIAL_SAMPLES) && !!index,
	({ index }) => locale.getEnumName(xml.enumCreate(COLOR_MATERIAL_SAMPLES, index.toString())),
);

